/* Jump tracings in article bodies (figure.ast-trace, styled in ast-trace.css; both files are loaded by
   sections/article-hub-layout.liquid only when the body has one): each drawing plays once when most of it
   is in view, then stays drawn, and a "Play again" button replays it. Without this script, without
   IntersectionObserver, or with reduced motion, the finished drawing shows and there is no button. */
(function () {
  var figs = document.querySelectorAll('figure.ast-trace');
  if (!figs.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function play(fig) {
    fig.classList.remove('is-playing');
    void fig.getBoundingClientRect(); /* restart the CSS animations from the first frame */
    fig.classList.add('is-playing');
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      play(entry.target);
    });
  }, { threshold: 0.6 });
  Array.prototype.forEach.call(figs, function (fig) {
    if (fig.dataset.astTrace) return;
    fig.dataset.astTrace = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ast-trace__replay';
    btn.textContent = 'Play again';
    var label = fig.querySelector('svg');
    btn.setAttribute('aria-label', 'Play again, ' + ((label && label.getAttribute('aria-label')) || 'tracing').replace(/, seen from above$/, ''));
    btn.addEventListener('click', function () { play(fig); });
    fig.appendChild(btn);
    fig.classList.add('is-armed');
    io.observe(fig);
  });
})();
